import { render, staticRenderFns } from "./ContentTypes.vue?vue&type=template&id=90f4f54c&scoped=true"
import script from "./ContentTypes.vue?vue&type=script&lang=js"
export * from "./ContentTypes.vue?vue&type=script&lang=js"
import style0 from "./ContentTypes.vue?vue&type=style&index=0&id=90f4f54c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f4f54c",
  null
  
)

export default component.exports